import { Empty } from 'antd';

import './EmptyList.less';

const RoleEmptySection = () => (
  <Empty className='tt-empty-list' image={Empty.PRESENTED_IMAGE_SIMPLE} />
);

export default RoleEmptySection;
